// authFetch.ts
import { handleSessionExpired } from "@/authSession.ts"

import { getToken } from "./getToken"

export const authFetch = async (url: string, options: RequestInit = {}) => {
  let token: string

  try {
    token = await getToken()
  } catch (err) {
    console.error("Token acquisition failed:", err)
    throw new Error(
      `Unable to acquire token: ${err instanceof Error ? err.message : "Unknown error"}`,
    )
  }

  const defaultHeaders = {
    Authorization: `Bearer ${token}`,
  }

  const headers = { ...options.headers, ...defaultHeaders }

  const response = await fetch(url, { ...options, headers })

  // If backend returns 401 (e.g. it sees an expired token), also bounce
  if (response.status === 401) {
    handleSessionExpired()
  }

  return response
}
